import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { useDashboardStatsQuery } from '@/hooks/queries/useDashboardStatsQuery';
import { queryKeys } from '@/hooks/queries/queryKeys';

export function useDashboardStatsDomain() {
    const queryClient = useQueryClient();
    const { isAuthenticated, isLoading: authLoading } = useAuth();
    const enabled = isAuthenticated && !authLoading;

    const statsQuery = useDashboardStatsQuery(enabled);

    const refreshStats = () => {
        queryClient.invalidateQueries({ queryKey: queryKeys.dashboardStats });
    };

    return {
        // Data
        dashboardStats: statsQuery.data ?? {
            totalOrders: 0,
            pendingOrders: 0,
            inProgressOrders: 0,
            completedOrders: 0,
            urgentOrders: 0,
            incidentCount: 0,
            materialCount: 0,
            revenue: 0,
        },
        
        // Actions
        refreshStats,
        
        // Loading States
        isLoading: statsQuery.isLoading,
        isFetchingStats: statsQuery.isFetching,
        
        // Error state
        error: statsQuery.error
    };
}
